import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/legal.css";

const TermsPage = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main className="legal-page">
        <h1>Terms &amp; Conditions</h1>
        <p className="legal-meta">Effective Date: July 28, 2026</p>

        <p>
          These Terms &amp; Conditions ("Terms") govern your access to and use
          of the Continental Lease Advisors LLC website ("Site"). By accessing
          or using the Site, you agree to be bound by these Terms. If you do not
          agree, do not use this Site.
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          Your continued use of this Site constitutes your ongoing acceptance of
          these Terms and any updates we make to them. We may revise these Terms
          at any time by updating this page; the "Effective Date" reflects the
          date of the most recent revision.
        </p>

        <h2>2. Use of the Site</h2>
        <p>You may use this Site only for lawful purposes. You agree not to:</p>
        <ul>
          <li>
            Use any automated system (including bots, crawlers, or scrapers) to
            access the Site without our prior written consent
          </li>
          <li>
            Attempt to gain unauthorized access to any portion of the Site or
            its underlying systems or networks
          </li>
          <li>
            Transmit harmful, deceptive, obscene, or illegal content through the
            contact form or any other means
          </li>
          <li>
            Misrepresent your identity or affiliation when contacting us through
            the Site
          </li>
          <li>
            Interfere with or disrupt the integrity or performance of the Site
          </li>
          <li>
            Use the Site in any way that violates applicable federal, state, or
            local laws or regulations
          </li>
        </ul>

        <h2>3. Intellectual Property</h2>
        <p>
          All content on this Site — including but not limited to text, images,
          graphics, logos, icons, and page layouts — is owned by or licensed to
          Continental Lease Advisors LLC and is protected under U.S. and
          international copyright, trademark, and other intellectual property
          laws.
        </p>
        <p>
          You may not copy, reproduce, distribute, modify, publicly display, or
          create derivative works from any content on this Site without our
          prior written permission.
        </p>

        <h2>4. Disclaimer of Warranties</h2>
        <p>
          This Site and all content are provided <strong>"as is"</strong> and{" "}
          <strong>"as available"</strong> without any warranties of any kind,
          express or implied, including but not limited to implied warranties of
          merchantability, fitness for a particular purpose, or
          non-infringement.
        </p>
        <p>
          We do not warrant that the Site will be uninterrupted, error-free, or
          free of viruses or other harmful components, or that defects will be
          corrected.
        </p>

        <h2>5. No Professional Advice</h2>
        <p>
          Content on this Site is for general informational purposes only.
          Nothing on this Site constitutes legal, financial, investment, or
          professional advice. For advice specific to your situation, consult a
          qualified professional.
        </p>

        <h2>6. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by applicable law, Continental Lease
          Advisors LLC, its members, officers, employees, and agents will not be
          liable for any indirect, incidental, special, consequential, or
          punitive damages arising out of or related to your access to or use of
          (or inability to access or use) this Site or its content, even if we
          have been advised of the possibility of such damages.
        </p>
        <p>
          Our total liability for any claim arising from or related to the Site
          will not exceed one hundred dollars ($100).
        </p>

        <h2>7. Third-Party Links</h2>
        <p>
          This Site may contain links to third-party websites. We provide these
          links for convenience only and do not endorse, control, or assume
          responsibility for the content, practices, or privacy policies of any
          linked site. Accessing third-party sites is at your own risk.
        </p>

        <h2>8. Contact Form Submissions</h2>
        <p>
          By submitting the contact form, you represent that the information you
          provide is accurate and that you have authority to contact us on behalf
          of any company you identify. You agree not to submit confidential or
          proprietary information through the contact form without first
          establishing a confidentiality agreement with us.
        </p>

        <h2>9. Governing Law &amp; Dispute Resolution</h2>
        <p>
          These Terms are governed by the laws of the State of Illinois, without
          regard to its conflict-of-law provisions. Any dispute arising out of
          or relating to these Terms or your use of the Site will be resolved
          exclusively in the state or federal courts located in Cook County,
          Illinois, and you consent to the personal jurisdiction of those courts.
        </p>

        <h2>10. Severability</h2>
        <p>
          If any provision of these Terms is found to be unenforceable, that
          provision will be modified to the minimum extent necessary to make it
          enforceable, and the remaining provisions will continue in full force
          and effect.
        </p>

        <h2>11. Entire Agreement</h2>
        <p>
          These Terms, together with our Privacy Policy, constitute the entire
          agreement between you and Continental Lease Advisors LLC regarding your
          use of this Site and supersede all prior agreements on that subject.
        </p>

        <h2>12. Contact</h2>
        <p>
          Questions about these Terms? Contact us at:{" "}
          <a href="mailto:[CONTACT EMAIL]">[CONTACT EMAIL]</a>
        </p>

        <div className="legal-placeholders">
          <p>Placeholders to fill in before publishing:</p>
          <ul>
            <li>[CONTACT EMAIL] — legal/general contact email address</li>
          </ul>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default TermsPage;